












































































































































































































































// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck Fix typing issues later
import { Vue, Component, Prop } from "vue-property-decorator";
import { required, email } from "vuelidate/lib/validators";
import {
  Input,
  FileUpload,
  SvgIcon,
  Switcher,
  Dropdown,
} from "@brankas/web-ui";

import { ClientInfo, TFile, TFileUpload } from "@/types";
import {
  ECountryCode,
  EDomicileTypes,
  EUserRoles,
  EUserTypes,
} from "@/pagesCom/ClientInfo/index.dto";
import {
  ETypeOfPIC,
  ETypeOfDoc,
  ERequirementDocs,
  getIdentificationDocumentSub,
} from "./helpers";
import { namespace } from "vuex-class";
import Radio from "@/components/radio/Radio.vue";
import { PersonInfoFormData } from "./index.vue";
import { COUNTRY_MOBILE_CODES } from "@/constant";

const clientModule = namespace("client");
const configModule = namespace("config");

@Component({
  components: {
    Input,
    FileUpload,
    SvgIcon,
    Radio,
    Switcher,
    Dropdown,
  },
  validations: {
    formData: {
      required,
      $each: {
        email: {
          required,
          email,
        },
        fullName: {
          required,
        },
        role: {
          required,
        },
        phoneNumber: {
          required,
        },
        phoneNumberCountryCode: {
          required,
        },
        directorOfCompany: {},
        isSameWithBizOwner: {},
      },
    },
  },
})
export default class PICForm extends Vue {
  @clientModule.State("currentClient") currentClient!: ClientInfo;
  @configModule.Getter("isJKTDashboard") isJKTDashboard!: boolean;

  @Prop({ type: String, default: ETypeOfPIC.AS }) typeOfPic!: ETypeOfPIC;
  @Prop({ type: Array, default: "" }) formData!: PersonInfoFormData[];

  typeOfDoc = ETypeOfDoc;
  userRoles = EUserRoles;
  countryMobileCodesOption = Object.values(COUNTRY_MOBILE_CODES);
  defaultRadioOptions = [
    {
      label: "Yes",
      value: "yes",
    },
    {
      label: "No",
      value: "no",
    },
  ];

  get isPersonal(): boolean {
    return this.currentClient?.userType === EUserTypes.INDIVIDUAL;
  }

  get computedSampleTemplate(): ERequirementDocs {
    return ERequirementDocs[
      Object.keys(ECountryCode)[
        Object.values(ECountryCode).indexOf(
          this.currentClient?.country as ECountryCode
        )
      ] as keyof typeof ERequirementDocs
    ];
  }

  get title() {
    return this.typeOfPic === ETypeOfPIC.AS
      ? "Authorized Signatory"
      : "Billing PIC";
  }

  get identificationDocument() {
    return getIdentificationDocumentSub(
      this.currentClient?.country as ECountryCode
    );
  }

  get computedCountry() {
    return this.currentClient?.country || "";
  }

  get isCountryID() {
    return this.computedCountry === ECountryCode.ID;
  }

  get isCountryPH() {
    return this.computedCountry === ECountryCode.PH;
  }

  get isLocalDomicile() {
    return this.currentClient.domicileType === EDomicileTypes.LOCAL;
  }

  get showDirectorIdentification() {
    return this.isCountryID && !this.isPersonal && this.isJKTDashboard;
  }

  get showPHDirectorPOA() {
    return this.isCountryPH && !this.isPersonal && this.isLocalDomicile;
  }

  toggleDisabledFields(index: number, keyName?: "role" | "upload") {
    let result;
    if (!this.formData[index]) return false;

    const isForUpload = keyName === "upload";

    if (this.typeOfPic === ETypeOfPIC.BILL && this.isPersonal) {
      result = this.formData[index].isSameWithBizOwner;
      return isForUpload ? !result : result;
    }

    if (isForUpload) return this.formData[index].directorOfCompany[0] === "no";
    const isRole = keyName === "role";
    return this.formData[index].directorOfCompany[0] === "yes" && isRole;
  }

  getFileUploadValue(payload: string) {
    if (!payload) return;
    const [type, index] = payload.split("-");

    return (
      this.formData[Number(index)][type as ETypeOfDoc] as TFileUpload[]
    ).map((item) => item.file as File);
  }

  onInputFile(files: TFile[], payload: string) {
    this.$emit("onInputFile", files, payload);
  }

  onInputPhone(value: string, payload: string) {
    this.$emit("onInputPhone", value, payload);
  }

  onAddForm() {
    this.$emit("onAddForm", this.typeOfPic);
  }

  onRemoveForm(index = 0, formID = "") {
    this.$emit("onRemoveForm", this.typeOfPic, index, formID);
  }

  onToggleBizOwnerAndDirector(
    val: boolean | ["yes" | "no"],
    payload: string,
    userRoles: EUserRoles
  ) {
    this.$emit(
      "onToggleBizOwnerAndDirector",
      Array.isArray(val) ? val[0] === "yes" : val,
      payload,
      userRoles
    );
  }
}
